import {Study} from "./metadata";
import { StrategicPillar } from "../services/strategic-pillar.service";
import { UserAudienceResponse } from "../services/audience.service";

const DEFAULT_TIMESPAN_MONTHS = {
  past: -15,
  future: 36
}

export type EntityTypeFilter = 'publications' | 'activities' | 'vvpmActivities' | 'congresses' | 'milestones';

export class Filter {
  [key: string]: any
  static readonly DEFAULT_TIMESPAN_START = this.getBoundaryDate(true)
  static readonly DEFAULT_TIMESPAN_END = this.getBoundaryDate(false)

  timespan: {start: Date, end: Date}
  studies: Array<Study> = []
  persons: Array<string> = []
  targets: Array<string> = []
  global: string = ""
  
  // Entity type filters — all enabled by default
  entityTypes: EntityTypeFilter[] = ['publications', 'activities', 'vvpmActivities', 'congresses', 'milestones']
  
  // Strategic Pillars and Audiences filters
  strategicPillars: StrategicPillar[] = []
  audiences: UserAudienceResponse[] = []

  constructor() {
    const cur = new Date()
    cur.setDate(1)
    this.timespan = {
      start: Filter.DEFAULT_TIMESPAN_START,
      end: Filter.DEFAULT_TIMESPAN_END
    }
  }
  
  /**
   * Checks if a specific entity type should be shown based on current filters
   * Empty entityTypes array means show all
   */
  shouldShowEntityType(type: EntityTypeFilter): boolean {
    if (this.entityTypes.length === 0) {
      return true; // Show all when nothing is selected
    }
    return this.entityTypes.includes(type);
  }

  private static getBoundaryDate(start: boolean){
    const now = new Date()
    return start
      ? this.setToStartOfMonth(this.addMonths(now, DEFAULT_TIMESPAN_MONTHS.past))
      : this.setToEndOfMonth(this.addMonths(now, DEFAULT_TIMESPAN_MONTHS.future))
  }

  private static setToStartOfMonth(d: Date): Date{
    return new Date(new Date(d.setDate(1)).setHours(0, 0, 0, 0))
  }

  private static setToEndOfMonth(d: Date){
    return new Date(this.setToStartOfMonth(this.addMonths(d, 1)).setMilliseconds(-1))
  }

  private static addMonths(d: Date, m: number): Date{
    const retDate = new Date(d)
    const years = Math.trunc(m/12)
    const months = m%12
    retDate.setFullYear(d.getFullYear() + years, d.getMonth() + months)
    return new Date(retDate)
  }
}
